import { NgModule } from '@angular/core';
import { LazyLoadDirective } from './lazy-load.directive';

const DECLARATIONS = [LazyLoadDirective];

@NgModule({
    imports: [],
    declarations: [...DECLARATIONS],
    exports: [...DECLARATIONS]
})
export class CommonDirectivesModule {}
